<template>
  <v-main>
            <app-loading v-if="loading"></app-loading>
            <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-layout>
            <v-container  v-if="!loading">
                <v-toolbar dense>
                    <v-toolbar-title>
                        <v-btn class="blue--text" outlined text router :to="'/numberPortal/' + this.phoneNumber + '/?userId=' + this.contactNumber" >
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                        <v-icon large>person</v-icon>
                        {{selectedConvo.name}}</v-toolbar-title>
                </v-toolbar>
            <v-container fluid>
                <!--user Profile-->
                <!--profile-->
                <v-card class="mb-1">
                    <v-card-title>
                       Profile
                    </v-card-title>
                    <v-card-text>
                            <v-list>
                                <v-list-item>
                                  <v-list-item-avatar>
                                    <v-icon>person</v-icon>
                                  </v-list-item-avatar>
                                    <v-text-field
                                            clearable
                                            v-model="clientName"
                                    ></v-text-field>
                                </v-list-item>
                              <v-list-item>
                                <v-list-item-avatar>
                                  <v-icon>business</v-icon>
                                </v-list-item-avatar>
                                <v-text-field
                                    clearable
                                    v-model="companyName"
                                ></v-text-field>
                              </v-list-item>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon>call</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="text-xs-left font-weight-light">
                                      {{formatPhoneNumber(selectedConvo.phoneNumber)}}
                                    </v-list-item-content>
                                </v-list-item>
                              <v-list-item>
                                <v-list-item-avatar>
                                  <v-icon>email</v-icon>
                                </v-list-item-avatar>
                                <v-text-field
                                    clearable
                                    v-model="email"
                                ></v-text-field>
                              </v-list-item>
                                <v-list-item v-if="meetupLocation">
                                    <v-list-item-avatar>
                                        <v-icon>location_on</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content v-if="!editLocation" >
                                        <h5 class="font-weight-light">
                                            <a style="text-decoration:none" class="blue--text" target="_blank" :href="'https://www.google.com/maps/place/' + meetupLocation.formatted_address">
                                                <div class="text-h6">{{meetupLocation.formatted_address}}</div>
                                            </a>
                                        </h5>
                                    </v-list-item-content>
                                    <v-btn v-if="!editLocation" icon @click="meetupLocation = null">
                                        <v-icon class="red--text">close</v-icon>
                                    </v-btn>
                                </v-list-item>
                                <v-list-item v-if="!meetupLocation">
                                  <locations-autocomplete @locationFound="saveNewlocation"></locations-autocomplete>
                                </v-list-item>
                            </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!loading" @click="updateName"
                               class="blue--text"
                               text outlined>
                            Update</v-btn>
                    </v-card-actions>
                </v-card>
                <!--message-->
                <v-card class="mb-1">
                    <v-card-title>
                            Message
                    </v-card-title>
                    <v-card-text>
                       <v-list>
                           <v-list-item>
                               <v-list-item-avatar>
                                   <v-icon>restore</v-icon>
                               </v-list-item-avatar>
                               <v-list-item-content>
                               {{moment(selectedConvo.lastActive)}}
                               </v-list-item-content>
                           </v-list-item>
                           <v-list-item>
                               <v-list-item-avatar>
                                   <v-icon>sms</v-icon>
                               </v-list-item-avatar>
                              <v-list-item-content>
                                  {{selectedConvo.lastMessage}}
                              </v-list-item-content>
                           </v-list-item>
                           <v-list-item v-if="selectedConvo">
                               <v-list-item-action>
                                   <v-icon>add</v-icon>
                               </v-list-item-action>
                               <v-list-item-content v-if="selectedConvo.notes">
                                   {{selectedConvo.notes}}
                               </v-list-item-content>
                           </v-list-item>
                           <v-list-item>
                               <v-list-item-content>
                                   <v-btn class="blue--text"
                                          text outlined @click="addNoteDialog = true">
                                       <v-icon>add</v-icon>
                                       Note
                                   </v-btn>
                               </v-list-item-content>
                           </v-list-item>
                       </v-list>
                    </v-card-text>
                </v-card>
                <!--email-->
              <v-card class="mb-1" v-if="email !== ''">
                <v-card-title>
                  Email
                </v-card-title>
                <v-card-text>
                  <email-template-sender :emailData="emailData"></email-template-sender>
                </v-card-text>
              </v-card>
                <!--Segments-->
                <v-card class="mb-1" v-if="selectedConvo">
                    <v-card-title>
                        Segments
                    </v-card-title>
                    <v-card-text v-if="selectedConvo.segments">
                        <v-layout row v-for="segment in selectedConvo.segments" :key="segment.created">
                            <v-flex>
                                <v-btn @click="updateSegmentName(segment)" block :color="segment.colour">{{segment.name}}</v-btn>
                            </v-flex>
                        </v-layout>

                    </v-card-text>
<!--                   segments button-->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="blue--text"  text @click="loadSegments">View Segment</v-btn>
                        <v-btn class="blue--text"  outlined router to="/segments">Go to Segments</v-btn>
                    </v-card-actions>
                </v-card>
                <!--orders-->
                <v-card class="mb-1">
                    <v-card-title>
                        Orders
                    </v-card-title>
<!--                    active order-->
                    <v-card-text>
                        <v-list v-if="selectedConvo.activeBooking">
                            <v-list-item>
                                <v-list-item-content>
                                    <h3>Active Order</h3>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content
                                        @click="routeToOrder(selectedConvo.activeBooking)"
                                        v-if="selectedConvo.activeBooking">
                                    {{selectedConvo.activeBooking}}
                                </v-list-item-content>
                                <v-list-item-content>
                                    <v-btn outlined text @click="resetActiveOrder">reset</v-btn>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
<!--                    past orders-->
<!--                    <v-card-text>-->
<!--                        <v-list v-if="orders.length !== 0">-->
<!--                            <v-list-item>-->
<!--                                <v-list-item-content>-->
<!--                                    <h3>Past Order</h3>-->
<!--                                </v-list-item-content>-->
<!--                            </v-list-item>-->
<!--                            <v-list-item two-line v-for="(order, i) in orders" :key="i">-->
<!--                                <v-list-item-content @click="routeToOrder(order.orderData.id)" v-if="order.orderData">-->
<!--                                    <v-list-item-title>{{moment(order.orderData.created)}}</v-list-item-title>-->
<!--                                    <v-list-item-subtitle>{{order.orderData.id}}</v-list-item-subtitle>-->
<!--                                </v-list-item-content>-->
<!--                            </v-list-item>-->
<!--                        </v-list>-->
<!--                    </v-card-text>-->
                </v-card>
            </v-container>
                <v-dialog v-model="segmentDialog"
                          ref="dialog"
                          persistent
                          width="290px"
                >
                    <v-card>
                        <v-card-title>
                            <div class="white black--text text-xs-center font-weight-thin headline">Segments</div>
                        </v-card-title>
                        <v-card-text v-if="segments">
                            <v-list>
                                <v-list-item
                                        v-for="item in segments"
                                        :key="item.created"
                                        @click="addUserToSegment(item)"
                                >
                                    <v-list-item-content >
                                        <v-list-item-title>{{item.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                            </v-list>

                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="outlined" @click="segmentDialog = false">close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="addNoteDialog"
                          persistent
                          width="290px"
                >
                    <v-card>
                        <v-card-title>
                            <div class="white black--text text-xs-center font-weight-thin headline">Notes</div>
                        </v-card-title>
                        <v-card-text>
                            <v-textarea
                                    label="Pass, apt.."
                                    v-model="note"
                                    auto-grow
                                    outlined
                                    rows="6"
                                    row-height="20"
                            ></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="blue--text"
                                   text outlined @click="addNote">Add Note</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-container>
        </v-main>
</template>
<script>
// update user contacts profile when updating contacts sms profile
    import moment from "moment"
    import {doc, onSnapshot, updateDoc} from "firebase/firestore";
    export default {
        props: ["phoneNumber", "contactNumber"],
        data () {
            return {
                selectedConvo: undefined,
                clientName: '',
                companyName: '',
                meetupLocation: undefined,
                editLocation: false,
                orders: [],
                segments: undefined,
                segmentDialog: false,
              addNoteDialog: false,
              note: undefined,
              email: ''
            }
        },
        computed: {
          momentShortDate () {
            return (date) => {
              //console.log(date)
              let dateSince = Date.now() - date
              //console.log(dateSince)
              let day
              if (dateSince < 86400) {
                day = moment(date).format('hh:mm A')
              }
              // day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
              return day
            }
          },
          moment () {
            return (date) => {
              let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
              return day
            }
          },
          error () {
            return this.$store.getters.error
          },
          loading () {
            return this.$store.getters.loading
          },
          user () {
            return this.$store.getters.user
          },
          emailData () {
            if (this.email !== '') {
              let obj = {
                toEmail: this.email
              }
              if (this.selectedConvo) {
                obj.toName = this.selectedConvo.name
              }
              return obj
            } else {
              return null
            }
          }
        },
        created() {
          this.$store.dispatch('setLoading', true)
          let db = this.$store.state.db
          let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'sms', this.contactNumber)
          return onSnapshot(smsRef ,doc => {
            if(doc.exists) {
              let data = doc.data()
              this.selectedConvo = data
              console.log(data)
              this.clientName = data.name
              if(data.companyName) {
                this.companyName = data.companyName
              }
              if(data.meetupLocation) {
                this.meetupLocation = data.meetupLocation
              }
              if(data.email) {
                this.email = data.email
              }
              if(data.notes) {
                this.note = data.notes
              }
              this.$store.dispatch("setLoading", false)
            }
            else {
              this.$store.dispatch("setError", {message: "No User Found"})
            }
          })
            // this.$store.state.db2.collection('fulfillment')
            //   .where("clientId", "==", this.phoneNumber)
            //     .onSnapshot(res => {
            //         if(!res.empty){
            //             let orders = []
            //             res.forEach(doc => {
            //                 orders.push(doc.data())
            //             })
            //              //console.log(orders)
            //           let sorted = orders.sort((a,b) => b.margins.created - a.margins.created)
            //             this.orders = sorted
            //         }
            // })
        },
        methods: {
          formatPhoneNumber(phoneNumberString) {
            // console.log(phoneNumberString)
            let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
              let intlCode = (match[1] ? '+1 ' : '');
              return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
            }
            return null;
          },
          addNote () {
            let db = this.$store.state.db
            let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'sms', this.contactNumber)
            updateDoc(smsRef, {notes: this.note})
                .catch(err => {
                  this.$store.dispatch('setError', err)
                })
            this.addNoteDialog = false
          },
          routeToOrder (id) {
            this.$router.push("/sale/" + id)
            //console.log(id)
          },
          loadSegments () {
            this.segmentDialog = true
            this.$store.state.db.collection("segments")
                .get()
                .then(res => {
                  let segments = []
                  res.docs.forEach(doc => {
                    segments.push({...doc.data(), id: doc.id})
                  })
                  this.segments = segments
                })
          },
          addUserToSegment (segment) {
            this.segmentDialog = false
            let userSegments = this.selectedConvo.segments
            if (userSegments) {
              let segFound = userSegments.find(seg => {
                return seg.id === segment.id
              })
              if (segFound) {
                return
              } else {
                this.$store.state.db.collection('segments').doc(segment.id)
                    .collection('users').doc(this.selectedConvo.phoneNumber)
                    .set(this.selectedConvo)
                    .then(() => {
                      return this.$store.state.db.collection('SMS')
                          .doc(this.selectedConvo.phoneNumber).get()
                    })
                    .then(res => {
                      let userData = res.data()
                      if (userData.segments) {
                        userData.segments.push(segment)
                      } else {
                        userData.segments = []
                        userData.segments.push(segment)
                      }
                      return this.$store.state.db.collection('SMS')
                          .doc(this.selectedConvo.phoneNumber).update(userData)
                    })
                    .catch(err => {
                      this.$store.dispatch('setError', err)
                    })
              }

            }
          },
          updateSegmentName (segment) {
            this.$store.state.db.collection('segments')
                .doc(segment.id).get()
                .then(res => {
                  let segmentData = res.data()
                  let currentSegment = this.selectedConvo.segments.find(seg => {
                    return seg.created === segment.created
                  })
                  let index = this.selectedConvo.segments.indexOf(currentSegment)
                  this.selectedConvo.segments[index].name = segmentData.name
                  return this.$store.state.db.collection('SMS').doc(this.phoneNumber).update(this.selectedConvo)
                })

          },
          userMessaging () {
            this.$router.push()
          },
          updateName () {
            //console.log(this.clientName)
            let db = this.$store.state.db
            let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'sms', this.contactNumber)
            updateDoc(smsRef, {
              name: this.clientName,
              email: this.email,
              companyName: this.companyName
            })
                .catch(err => {
                  this.$store.dispatch('setError', err)
                })
          },
          resetActiveOrder () {
            let db = this.$store.state.db
            let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.selectedConvo.connectedPhoneNumber, 'sms', this.selectedConvo.phoneNumber)
            updateDoc(smsRef, {activeBooking: null})
                .catch(err => {
                  this.$store.dispatch('setError', err)
                })
          },
          saveNewlocation (value) {
            this.editLocation = false

            let db = this.$store.state.db
            let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'sms', this.contactNumber)
            updateDoc(smsRef, {meetupLocation: value})
                .catch(err => {
                  this.$store.dispatch('setError', err)
                })
          }
        }
    }
</script>
